module.exports = __webpack_public_path__ + "static/14-f944f006f7f76801e3eea2d489eb761d.jpg";